
  <div class="mnt-content mdl-grid mdl-grid--no-spacing">
    <div class="mdl-cell mdl-cell--12-col ">
       <itec-form
            name="ctrl.formulari.nom"
            fields="ctrl.formulari.camps"
            ng-model="ctrl.cercaObj"
            ng-submit-function="ctrl.formulari.func()"
            errors="ctrl.errors"
            submit-button-text="DEFAULT_CERCAR"
            backbutton="false"
            submit-button-dynamic="false">
          </itec-form>

    </div>
  </div>
  <div class="mdl-grid mdl-grid--no-spacing">
    <div class="tcqi--padding-right-5 tcqi--padding-left-5 tcqi--padding-top-10 tcqi--padding-bottom-5">
      <div class="circle-ok"></div> {{::'USUARI_CONFIRMAT_TITOL' | translate}}
      <div class="circle-vermell"></div>&nbsp;{{'USUARI_NO_REGISTRAT_HEADER' | translate}}
      <div class="circle-groc"></div>&nbsp;{{'USUARI_NO_CONFIRMAT_HEADER' | translate}}  </div>
    <itec-simple-list
      class="mdl-cell mdl-cell--12-col"
      items="ctrl.llista"
      fields="ctrl.fields"
      show-edit-button="$root.permisos.ACTUALITZARUSUARI.edit"
      show-delete-button="$root.permisos.ESBORRARUSUARI.delete"
      show-add-button="false"
      itec-dialog-confirm-title="DEFAULT_TITOL_CONFIRMACIO_ESBORRAR"
      itec-dialog-confirm-text-content="USUARI_DELETE_CONTENT"
      itec-infinite-scroll-function="ctrl.load"
      threshold="100"
      can-load="ctrl.canLoad"
      delete-function="ctrl.deleteUsuari"
      click-function="ctrl.view"
      all-row-clickable="true"
      edit-function="ctrl.edit"
      id-selected="$stateParams.idUsuari"
      formatter-function="ctrl.formatter">
    </itec-simple-list>
  </div>
</div>
